import { ActionButtonProps, Box, ColorOptions, convertHexToRGBA, Form, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { ReactElement, useEffect, useState } from 'react'
import { Keyboard } from 'react-native'
import { ChangeMobileNumber } from '../../comps/ChangeMobileNumber'
import { DefaultFormContainer } from '../../comps/DefaultFormContainer'
import { SvgImage } from '../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getString } from '../../util/languageStrings'
import { Colors, logEvent, testProps, useWindowDimensions } from '../../util/util'
import { otpForm } from './FormDataForMobile'
import { ResendOtp } from './ResendOtp'
import { styles } from './styles'

const renderOtpActionButtons = ({
  defaultActionButtonOnSubmit,
  values,
  isValid,
  handleVerifyPress,
  // buttonContainer,
  otpApiHandler,
  themedStyle,
  otpValue,
  isLoading,
  mobileNumber,
  updateConsentCheckbox,
  selectedAppLanguage,
}: any): ReactElement => {
  // if (String(otpValue)?.trim()?.length > 5) {
  //   setTimeout(() => {
  //     handleVerifyPress(String(otpValue))
  //   }, 10)
  // }

  const handleOtpSubmitPress = (): void => {
    defaultActionButtonOnSubmit()
    // TODO: Scenarios 1: login can be done thru different device which SMS not be received
    // Scenarios 2: User may enter OTP manually
    // Scenarios 3: For android OTP will be autofilled when SMS received.
    if (isValid) {
      updateConsentCheckbox(true)
      logEvent('btn_press', 'continue_otp')
      handleVerifyPress(String(values?.otp))
    }
  }
  return (
    <>
      <Box
        {...themedStyle.otpButtonContainer}
        borderRadius={24}
        h={48}
        bg={Colors.PRIMARY as ColorOptions}
        align={'center'}
        justify={'center'}
        marginTop={40}
        onPress={handleOtpSubmitPress}
        underlayColor={Colors.PRIMARY as ColorOptions}
        {...testProps('verify-otp-button')}>
        <Text hide={isLoading} color={'WHITE'} fontFamily={'JioType-Bold'} fontSize={16} letterSpacing={-0.08}>
          {getString(selectedAppLanguage, 'continue')}
        </Text>
      </Box>
      <Box pv={16}>
        <ResendOtp count={30} mobile={mobileNumber} />
      </Box>
    </>
  )
}

const OtpMobile = ({ params }) => {
  const mobileNumber = params?.mobileNum
  const isSignUp = params?.isSignUp
  const isFromForgotPwd = params?.isFromForgotPwd ?? false
  const { setSessionVerified, otpVerify, resetAccessToken, updateConsentCheckbox, selectedAppLanguage } = useStores(
    (root) => ({
      setSessionVerified: root.user.session.setSessionVerified,
      otpVerify: root.user.loginVerifyOTP,
      resetAccessToken: root.user.session.resetAccessToken,
      updateConsentCheckbox: root.user.updateConsentCheckbox,
      selectedAppLanguage: root.settings.config.selectedAppLanguage,
    }),
  )

  const navigation = useNavigation()
  // const appState = useRef(AppState.currentState)
  const [otpValue, setOtpValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [verifyOTP, { state }] = useLazyApiData(otpVerify)
  const viewPortWidth = useWindowDimensions()

  useEffect(() => {
    if (state === 'fulfilled') {
      setSessionVerified(true)
      setIsLoading(false)
      navigation?.navigate(Routes.RESET_PASSWORD, { path: Routes.RESET_PASSWORD, isSignUp: true, otp: otpValue })
    } else if (state === 'pending') {
      setIsLoading(true)
    } else if (state === 'rejected') {
      setIsLoading(false)
    }
  }, [navigation, otpValue, setSessionVerified, state])

  const initValues = {
    otp: otpValue ?? '',
  }

  // const error = data?.message ?? ''
  // const isErrorVisible = error?.length > 0 ?? false

  const navigateToSetResetPassword = (otp: string) => {
    navigation?.navigate(Routes.RESET_PASSWORD, { path: Routes.RESET_PASSWORD, isSignUp: isSignUp, otp: otp })
  }

  const handleVerifyPress = (otp: string): void => {
    Keyboard.dismiss()
    if (!isFromForgotPwd) {
      isSignUp ? navigateToSetResetPassword(otp) : verifyOTP(otp, mobileNumber)
    } else {
      navigateToSetResetPassword(otp)
    }
  }

  const getFormData = (): any[] => {
    const initialFormData = [...otpForm()]
    return initialFormData
  }

  const handleOtpCancelPress = (): any => {
    Keyboard.dismiss()
    resetAccessToken()
    navigation?.goBack()
    // }
  }

  const renderAction = ({ defaultActionButtonOnSubmit, values, isValid }: ActionButtonProps): ReactElement => {
    return renderOtpActionButtons({
      defaultActionButtonOnSubmit,
      values,
      isValid,
      handleVerifyPress,
      // buttonContainer,
      state,
      themedStyle,
      otpValue,
      isLoading,
      mobileNumber,
      updateConsentCheckbox,
      selectedAppLanguage,
    })
  }

  const themedStyle = styles(viewPortWidth)

  const navigateToForgotPassword = () => {
    logEvent('btn_press', 'change_mobile_number_otp')
    navigation.navigate('forgotPassword')
  }

  return (
    <Box f={1} align={'center'} justify={'space-between'} bg={'SECONDARY'}>
      <Box w={'100%'} h={64} ph={16} align={'flex-start'} justify={'center'}>
        <Box onPress={handleOtpCancelPress} underlayColor="TRANSPARENT">
          <SvgImage imageName="HeaderArrowLeft" />
        </Box>
      </Box>
      <Box w={'100%'} {...themedStyle.cardContainer} mt={0} pt={0} f={1}>
        <Box
          {...themedStyle.card}
          borderBottomLeftRadius={0}
          borderBottomRightRadius={0}
          borderTopLeftRadius={24}
          paddingHorizontal={24}
          width={'100%'}
          borderTopRightRadius={24}
          flexGrow={1}
          mt={0}
          pt={0}>
          <Spacer direction={'vertical'} size={35} />
          <Text
            title={getString(selectedAppLanguage, 'verificationRequired')}
            fontFamily={'JioType-Black'}
            fontSize={24}
            lineHeight={32}
            letterSpacing={-0.12}
          />
          <Spacer direction={'vertical'} size={8} />
          <ChangeMobileNumber
            selectedAppLanguage={selectedAppLanguage}
            onPress={navigateToForgotPassword}
            mobileNumber={mobileNumber}
          />
          <Spacer direction={'vertical'} size={8} />
          <Text
            title={getString(selectedAppLanguage, 'sentAnOTP')}
            fontFamily={'JioType-Medium'}
            lineHeight={20}
            fontSize={14}
            letterSpacing={-0.07}
            color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
          />
          <Spacer direction={'vertical'} size={32} />
          <Box {...themedStyle.formContainer}>
            <Form
              initialValues={initValues}
              container={DefaultFormContainer}
              formData={getFormData()}
              actionButtons={renderAction}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default OtpMobile
